<template>
    <div class="c-user-action">

        <b-link v-if="options.reset.display"  @click="reset"  href="#" class="card-header-action btn-setting">
            {{Core.Definition.getDefinition('Réinitialiser')}}
        </b-link>
        <b-link v-if="options.add.display" @click="onCreateClick" href="#" class="card-header-action btn-setting">
            {{Core.Definition.getDefinition('Créer utilisateur')}}
        </b-link>
        <b-link @click="selectUser" href="#" class="card-header-action btn-setting">
            {{Core.Definition.getDefinition('Sélect. utilisateur')}}
        </b-link>

        <ModalUser
                ref="modalUser"
                @ok="newUser"
                v-model="dataUser"
                :validate="['firstname', 'lastname', 'email']"
                :ignoreRouteParamId="true">
        </ModalUser>

        <ModalInstanceSelector
                ref="modalInstanceSelector"
                root="/user/list"
                :searchFormStructure="{
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'firstname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'lastname'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'email'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'phone'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {}
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'number',
                            label: Core.Definition.getDefinition('ID'),
                            value: ''
                        },
                        {
                            id: 'firstname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Prénom'),
                            value: ''
                        },
                        {
                            id: 'lastname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Nom de famille'),
                            value: ''
                        },
                        {
                            id: 'phone',
                            type: 'text',
                            label: Core.Definition.getDefinition('Téléphone'),
                            value: ''
                        },
                        {
                            id: 'email',
                            type: 'text',
                            label: Core.Definition.getDefinition('Courriel'),
                            value: ''
                        }
                    ]
                }"
                v-model="dataUsers"
                :multiple="false"
                :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucun utilisateur à afficher'),
                                borderVariant: 'white',
                                noBody: true
                }"
                :columns="[
                                {
                                    label: Core.Definition.getDefinition('#'),
                                    key: 'id',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Prénom'),
                                    key: 'firstname',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Nom'),
                                    key: 'lastname',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Courriel'),
                                    key: 'email',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Téléphone'),
                                    key: 'phone',
                                    sortable: true
                                }
                 ]"></ModalInstanceSelector>
    </div>
</template>

<script>
    import ModalInstanceSelector from './ModalInstanceSelector'
    import ModalUser from './ModalUser'
  export default {
      name: 'UserAction',
      components: {
          ModalInstanceSelector,
          ModalUser
      },
      props: {
          options: {
              type: Object,
              default: function () {
                  return {
                      reset: {
                          display: true
                      },
                      add: {
                          display: false
                      }
                  }
              }
          },
          form: {
              type: Object,
              default: function () {
                  return {}
              }
          },
          fieldRefs: {
              type: Array,
              default: function () {
                  return []
              }
          },
          value: {
              type: Object,
              default: function () {
                  return {
                      id: '',
                      birthDate: null,
                      firstname: '',
                      lastname: '',
                      email: '',
                      phone:'',
                      mobile:'',
                      country: null,
                      province: null,
                      city: '',
                      address: '',
                      zipcode:''
                  }
              }
          }
      },
      watch: {
          value(val) {
              this.dataUser = val
          },
          dataUsers: {
              handler(val) {
                  if (val[0] !== undefined && val[0].instance !== undefined) {
                      this.dataUser = val[0].instance
                  }
              },
              deep: true
          },
          dataUser: {
              handler(val) {
                  this.$emit('input', val)
                  this.$emit('updateUser', val, this.form, this.fieldRefs)
              },
              deep: true
          }
      },
      mounted() {
          this.dataUser = this.value
      },
      data: () => {
          return {
              Core: window.Core,
              dataUsers: [],
              dataUser: {
                  id: '',
                  birthDate: null,
                  firstname: '',
                  lastname: '',
                  email: '',
                  phone:'',
                  mobile:'',
                  country: null,
                  province: null,
                  city: '',
                  address: '',
                  zipcode:''
              }
          }
      },
      methods: {
          onCreateClick() {
              this.reset()
              this.$refs.modalUser.open = true
          },
          newUser(user) {
              this.dataUser = user
          },
          selectUser() {
              this.$refs.modalInstanceSelector.open = true
          },
          reset() {
              this.dataUser = {
                  id: '',
                  firstname: '',
                  lastname: '',
                  email: '',
                  phone:'',
                  country: null,
                  province: null,
                  city: '',
                  address: '',
                  zipcode:''
              }
          }
      }
  }
</script>